























































































import _ from 'lodash';
import logo from '@/assets/logo.png';
import { IOrderDetails } from '@/service/types';
import { Component, Vue, Watch } from 'vue-property-decorator';
import LayoutMenu from '@/components/layout/parts/LayoutMenu.vue';
import { mapGetters, mapActions } from 'vuex';
import {
  State,
  Getter,
  Action,
  Mutation,
  namespace
} from 'vuex-class';
import { Computed, Debounce } from '@/decorators';

@Component({
  components: {
    LayoutMenu
  }
})
export default class LayoutBase extends Vue {
  // fields
  mainColor: string = 'black';
  drawer: boolean = false;
  textFieldOpened: boolean = false;
  logo: string = logo;
  search: string|undefined = '';

  closeDrawer() {
    if (this.drawer) {
      console.log('drawer is opened - closing...')
      this.drawer = false
    }
  }

  toggleDrawer() {
    this.drawer = !this.drawer;
  }
  
  // vuex
  @Computed({
    getter: 'order/searchQuery', 
    setter: 'order/updateSearchQuery'
  }) searchQuery: string;
  @Getter('isScannerConnected') isScannerConnected: boolean;
  @Getter('isOnline') isOnline: boolean;
  @Action('order/updateSearchQuery') updateSearchQuery(v: string|undefined): void {};
  @Getter('order/oneComposed') getOrderFromStorage: (id: number) => IOrderDetails;
  @Watch('searchQuery') watchSearchQuery(value: string) {
    this.search = value;
    if (this.search) {
      this.textFieldOpened = true;
    }
  }

  @Debounce(250) delayedInput(v: string|undefined) {
    this.updateSearchQuery(v);
    if (this.routeName !== 'dashboard-orders') {
      this.$router.push({name: 'dashboard-orders'});
    }
  }

  get indicatorsVisible() {
    return this.$vuetify.breakpoint.smAndUp || !this.textFieldOpened;
  }
  get logoVisible() {
    return this.$vuetify.breakpoint.smAndUp;
  }
  get visibleTextField() {
    return this.$vuetify.breakpoint.smAndUp || this.textFieldOpened;
  }
  get title() {
    if (this.routeName === 'dashboard-orders' && this.isCompact) {
      return this.$t('dashboard.orders.head.titleLayout');
    } 
    if (this.isOrderDetailsPage && this.order && this.isMobile) {
      return `${this.$t('dashboard.orderDetails.heading')} ${this.order.reference}`;
    }
    return this.$t('dashboard.title');
  }

  get routeName() {
    return this.$route.name;
    
  }
  mounted() {
    this.search = this.searchQuery;
  }

  get isCompact() {
    return this.$vuetify.breakpoint.mdAndDown;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get isOrderDetailsPage() {
    return this.order !== null && this.routeName === 'dashboard-order-detail';
  }

  get order() {
    let idOrder = _.get(this.$route, 'params.orderId', 0);
    // console.log(idOrder);
    if (idOrder) {
      let order = this.getOrderFromStorage(idOrder);
      // console.log(order);
      if (order) {
        return order;
      }
    }
    return null;
  }

  navigateToDashboard() {
    this.$router.push({name: 'dashboard-orders'});
  }
}
